import React from 'react';
import Chatroom from './Chatroom.js';
import './styles/App.css';

function RightSide(props) {
    return (
        props.room_id == -1 ? <div id="right_side"><h1 id="start_text">Let's start a chat !</h1></div> : <Chatroom room_id={props.room_id} user_email={props.user_email} handle_invite=
        {props.handle_invite} storage={props.storage}/>
    );
}
export default RightSide;